import HhTable from './hh-table';
export default HhTable;
